import React from 'react';

const LoadingPage = () => {
  const loadingPageStyle = {
    backgroundColor: '#067451',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', 
    fontSize: '24px',
    fontWeight: 'bold',
    marginTop:"5rem"
  };

  return (
    <div style={loadingPageStyle}>
      LOADING
    </div>
  );
};

export default LoadingPage;
